export type Line = {
  lineNumber: number;
  type: 'add' | 'del';
  content: string;
};

// reasons why a suggestion can't be applied (disables apply button)
export enum CannotApplyReasons {
  NOT_PERMITTED = 'applyButtonTooltipTextNotPermitted',
  INVALID_PR_STATE = 'applyButtonTooltipTextInvalidPrState',
  INVALID_COMMIT_COMMENT = 'applyButtonTooltipTextInvalidCommitComment',
  INVALID_OR_ORPHANED_COMMENT = 'applyButtonTooltipTextInvalidOrOrphanedComment',
  INVALID_COMMENT_STATE = 'applyButtonTooltipTextInvalidCommentState',
  INVALID_REMOVED_LINE = 'applyButtonTooltipTextInvalidRemovedLine',
  INVALID_DIFF_TYPE = 'applyButtonTooltipTextInvalidDiffType',
  PENDING_MERGE = 'applyButtonTooltipTextPendingMerge',
  REDUNDANT_SUGGESTION = 'applyButtonTooltipTextRedundantSuggestion',
}
